
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"rule.condition.separator":"AND","rule.condition.invalid":"\"Invalid display condition\"","of":"of","hintText.default":"View is not displayed. The display condition is not met."},"de":{"rule.condition.separator":"UND","rule.condition.invalid":"\"Ungültige Anzeigebedingung\"","of":"von","hintText.default":"Sicht wird nicht angezeigt. Die Anzeigebedingung ist nicht erfüllt."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();